import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsPageTitleStyles {
    container?: GridContainerProps;
    brandGridItem?: GridItemProps;
    brandStyles?: ProductBrandStyles;
    brandNameLink?: LinkPresentationProps;
    titleGridItem?: GridItemProps;
    titleText?: TypographyProps;
}

export const pageTitleStyles: ProductDetailsPageTitleStyles = {
    container: {
        gap: 0,
        offsetCss: css`
            max-width: 100%;
        `,
    },
    brandGridItem: {
        width: 12,
        css: css`
            > span {
                font-weight: bold;
                color: ${getColor("primary")};
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        null,
                        css`
                            width: 26% !important;
                        `,
                        null,
                    ])}
            }
        `,
    },
    brandStyles: {
        logoImage: {
            css: css`
                img {
                    max-width: 150px;
                    max-height: 150px;
                }
            `,
        },
        nameText: {
            size: 16,
            weight: "normal",
        },
        nameLink: {
            css: css`
                display: inline;
                > span {
                    font-size: 15px;
                }
            `,
        },
    },
    titleGridItem: {
        width: 12,
        css: css`
        `,
    },

    titleText: {
        variant: "h2",
        css: css`
            font-size: 24px;
            color: ${getColor("text.accent")};
            margin-bottom: 8px;
            line-height: 1.2;
            font-family: "Roboto-Medium";
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 22px;
                    `,
                    css`
                        font-size: 22px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    brandNameLink: {
        css: css`
            width: auto;
            margin-bottom: 8px;
            border-bottom: 1px solid #A22E31;
            line-height: 13px;
            font-family: "Roboto-Medium";
            font-weight: 400;
             span {
                width: 100%;
                font-size: 14px;
                font-family: "Roboto-Medium";
                color: #A22E31 !important;
                 font-weight: 400;
                a{
                padding: 0px;
                }
            }
        `,
    },
};

const styles = pageTitleStyles;

const ProductDetailsPageTitle: React.FC<Props> = ({ product }) => {
    return (
        <GridContainer {...styles.container}>
            {product.brand && (
                <GridItem {...styles.brandGridItem}>
                   <Link href={product.brand.detailPagePath} {...styles.brandNameLink}>
                       {translate("Brand:")} <ProductBrand brand={product.brand} showLogo={false} extendedStyles={styles.brandStyles} />
                    </Link>
                </GridItem>
            )}
            <GridItem {...styles.titleGridItem}>
                <Typography as="h1" {...styles.titleText} data-test-selector="productDetails_productDescription">
                    {product.productTitle}
                </Typography>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsPageTitle),
    definition: {
        displayName: "Page Title",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
